import { type ReactNode, useCallback, useMemo, useState } from 'react';
import TimeEntryRefreshContext from './TimeEntryRefreshProvider';

interface TimeEntryRefreshProviderProps {
  children: ReactNode;
}

/**
 * When applying overtime calculations, we need to ensure that the time entries are refreshed.
 * Because the time entries are using local state, we need to force a re-render
 * to ensure that the time entries are updated with the latest overtime calculations.
 */
export const TimeEntryRefreshProvider = ({ children }: TimeEntryRefreshProviderProps) => {
  const [refreshKey, setRefreshKey] = useState(0);

  const refreshTimeEntries = useCallback(() => {
    setRefreshKey((prev) => prev + 1);
  }, []);

  const value = useMemo(
    () => ({
      refreshKey,
      refreshTimeEntries,
    }),
    [refreshKey, refreshTimeEntries],
  );

  return <TimeEntryRefreshContext.Provider value={value}>{children}</TimeEntryRefreshContext.Provider>;
};
